module.exports = __webpack_public_path__ + "static/media/MRI_glitch.b0f70d15.jpeg";